const capturedErrors = new WeakSet<object>();

export const isSentryCapturedError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  if (capturedErrors.has(error)) return true;

  try {
    return '__sentry_captured__' in error && (error as { __sentry_captured__?: unknown }).__sentry_captured__ === true;
  } catch {
    return false;
  }
};

export const markSentryCaptured = (error: unknown): void => {
  if (!error || typeof error !== 'object') return;
  if (capturedErrors.has(error)) return;

  try {
    Object.defineProperty(error, '__sentry_captured__', {
      value: true,
      enumerable: false,
      configurable: true
    });
  } catch {
    try {
      (error as { __sentry_captured__?: boolean }).__sentry_captured__ = true;
    } catch {
      // ignore
    }
  }

  capturedErrors.add(error);
};
